import pensRouter from './pensRouter';

export default pensRouter;
